









import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class WievButton extends Vue {
  @Prop({ type: String, default: "grid" }) wiev!: string;
}
